// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCTrjx0ft-teSicq2ia1ukjtYIqJYnTdHI",
  authDomain: "portfolio-a0c89.firebaseapp.com",
  projectId: "portfolio-a0c89",
  storageBucket: "portfolio-a0c89.appspot.com",
  messagingSenderId: "617398177269",
  appId: "1:617398177269:web:d7205292b7e3c1d05d24bc",
  measurementId: "G-LX9LTP1MFJ",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6Ldz0CEdAAAAAHAuhkQCWbvbIUBPokDRJlVrsOqD"),
  isTokenAutoRefreshEnabled: true,
});
